import React, { Component } from 'react'

import { formatDate } from './../helper.js'
import { API_BASE_URL_DEV, API_BASE_URL_PROD } from './../config.js'

export default class Diary extends Component {
  constructor(props) {
    super(props)
    this.state = { post: { Title: '', Updated: Date.now() } }
  }

  componentDidMount() {
    const url =
      (process.env.NODE_ENV === 'development'
        ? API_BASE_URL_DEV
        : API_BASE_URL_PROD) + 'posts/last'

    fetch(url, {})
      .then(response => response.json())
      .then(json => this.setState({ post: json }))
  }

  transitionToBlog(event) {
    event.preventDefault()
    window.history.pushState(null, null, '/diary')
    window.dispatchEvent(new window.PopStateEvent('popstate'))
  }

  render() {
    return (
      <div
        className={'diary diary--' + this.props.category + ' diary--animated'}
        onClick={this.transitionToBlog.bind(this)}
        style={this.state.style}
      >
        <div className="diary-title">Diary</div>
        <div className="diary-subtitle">
          {this.state.post.Title.substring(0, 8) +
            (this.state.post.Title.length > 8 ? '...' : '')}
        </div>
        <div className="diary-date">
          {this.state.post.ID !== 0
            ? formatDate(this.state.post.CustomDate)
            : ''}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/front/components/diary.js